import { Factory, association } from 'miragejs'
import { faker } from '@faker-js/faker'
import { CategoriesByGroup } from 'teacher-ui-client/components/book-library/additional-filters-support'

const removeClassification = (id) => id.replace('nonfiction.', '').replace('fiction.', '')
const fictionCategories = CategoriesByGroup.fiction.categories.map(removeClassification)
const nonfictionCategories = CategoriesByGroup.nonfiction.categories.map(removeClassification)

export default Factory.extend({
  code() {
    return [faker.word.sample().toLowerCase(), faker.word.sample().toLowerCase()].join('_')
  },

  classification() {
    return faker.helpers.arrayElement(['fiction', 'nonfiction'])
  },

  primaryCategories() {
    const categories = this.classification === 'fiction' ? fictionCategories : nonfictionCategories
    return faker.helpers.arrayElements(categories, 2)
  },

  series() {
    return faker.helpers.arrayElement(['steam_science', 'go_facts', 'fast_phonics'])
  },

  exclude: false,

  // book always has a book metadata record generated and associated with it
  bookMetadata: association(),
})
